module.exports = __webpack_public_path__ + "img/recommended-icon.b5e70c89.png";